import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  applyDiscountBtn: {
    width: '200px',
    margin: 'auto'
  },
  removeDiscountBtn: {
    width: 24,
    height: 24,
    margin: 6
  }
}));

export default useStyles;
